<template>
    <div class="d-flex justify-content-center items-align-center">
        <div class="d-flex align-self-center">
            <spinner
                :size="size"
                class="text-primary"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        size: { default: 'large' },
    }
}
</script>
